import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { FuseUtils } from '../../../../../../core/fuseUtils';
import { fuseAnimations } from '../../../../../../core/animations';

//Service file
import { EcommerceOrdersService } from '../orders.service';

/** Local component */
import { ToastComponent } from '../../../common/toast.component';

/**Local files */

import { toastMsg, displayValues, toolTip } from '../../../utils/index';


@Component({
    selector: 'to-youtube',
    templateUrl: './toYoutube.component.html',
    styleUrls: ['./toYoutube.component.scss'],
    animations: fuseAnimations
})

export class UploadToYoutubeComponent {

    toastMsg = toastMsg;
    displayValues = displayValues;
    toolTip = toolTip;

    @ViewChild('fileInput') fileInput: ElementRef;
    youtubeForm: FormGroup;

    ytvideolist = [];
    nextPageToken: any;
    formErrors: any;

    dataSource: MatTableDataSource<ReportData>;

    displayedColumns = ['title', 'description', 'video'];
    manualFileName: any = '';

    currentTodo: string = null;
    isLoading: boolean = false;

    progress: number = 0;

    progressEventSubscription: Subscription;

    constructor(
        private formBuilder: FormBuilder,

        /** Local component */
        public toastComponent: ToastComponent,
        /** Service file */
        private ordersService: EcommerceOrdersService) {
    }

    ngOnInit() {



        /** Reactive form errors*/
        this.formErrors = {
            title: {},
            description: {},
            tags: {},
        };

        /** Form controls*/
        this.youtubeForm = this.formBuilder.group({
            title: ['', Validators.required],
            description: ['', Validators.required],
            tags: [''],
        });

        this.youtubeForm.valueChanges.subscribe(() => {
            this.onFormValuesChanged();
        });

        /** Update progress bar*/
        this.progressEventSubscription =
            this.ordersService.progressEventObservable
                .subscribe(
                    (event) => {
                        // console.log('eventaaa', event);
                        this.progress = event;

                    }
                );

        this.ordersService.youTubeVideos
            .subscribe((list) => {
                this.getVideos(list);
            }, () => {
                this.ytvideolist = [];
                this.toastComponent.showToast(this.toastMsg.failed);
            })

    }

    ngOnDestroy() {
        this.currentTodo = null;
        this.progressEventSubscription.unsubscribe();
    }

    /** Get videos from youtube */
    getVideos(ytresults) {
        this.ytvideolist = [];
        this.nextPageToken = ytresults.nextPageToken;

        if(ytresults && ytresults.items){

            ytresults.items.forEach(obj => {
                this.ytvideolist.push(obj);
            });

            if (ytresults.items.length == this.ytvideolist.length) {
                /**last items description about youtube channel-remove last element from array */
                this.ytvideolist.splice(-1, 1);
                this.dataSource = new MatTableDataSource(this.ytvideolist);
            }
        }
    }

    /** Get file contents once browsed */

    onFileChange(event) {

        let element = event.target;
        if (element.files.length > 0) {
            this.manualFileName = {
                filename: element.files[0].name,
                filetype: element.files[0].type,
                video: element.files[0]
            };
        }

    }

    /** To enable video upload form*/
    click() {

        this.currentTodo = 'youtube Form';

    }

    /** Upload to youtube */

    onSubmitFile() {

        this.isLoading = true;

        /** Read file content */
        let formData = new FormData();
        formData.append('video', this.manualFileName.video);

        this.ordersService.uploadToYoutube(this.manualFileName.video, this.youtubeForm.value)
            .then((res: any) => {

                switch (res.status) {

                    case 'Success':
                        this.toastComponent.showToast(this.toastMsg.videoUpload);
                        break;

                    case 'Failed':
                        this.toastComponent.showToast(res.message);
                        break;

                }

                this.isLoading = false;
                this.currentTodo = null;
                this.progress = 0;
                // this.clearFile();
                this.ordersService.fetchYoutubeVideo();

            })
            .catch(err => {
                this.isLoading = false;
            })

    }

    /** Clear seletcted video */
    clearFile() {

        this.fileInput.nativeElement.value = '';
        this.manualFileName = '';

    }

    /** On change function for form fields */
    onFormValuesChanged() {

        for (const field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.youtubeForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.formErrors[field] = control.errors;
            }
        }
    }

    /**
       * Filter table
       * @param filterValue 
       */
    applyFilter(filterValue: string) {

        var filterData = FuseUtils.filterArrayByString(this.ytvideolist, filterValue);
        this.dataSource = new MatTableDataSource(filterData);
    }

}
export interface ReportData {

    name: string;
    description: string;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/to-youtube/toYoutube.component.ts